import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo3D from '../components/Logo3D';

const Home = () => {
  const [isHovering, setIsHovering] = useState(false);
  const navigate = useNavigate();

  const handleExploreClick = () => {
    navigate('/explore');
  };

  return (
    <div className="w-full h-full">
      {/* Hero Section - Above the fold */}
      <section 
        className="relative flex items-center justify-center px-4"
        style={{ 
          height: 'calc(100vh - 60px)', // Account for header only (no bottom nav)
          minHeight: '500px' 
        }}
        aria-labelledby="hero-heading"
      >
        {/* Pure black background */}
        <div className="absolute inset-0 bg-black" />
        
        {/* Centered Chrome Logo */}
        <div className="relative w-full h-full max-w-4xl max-h-4xl">
          <Logo3D 
            className="w-full h-full"
            autoRotate={false}
            baseRotationSpeed={0}
            hoverRotationSpeed={0}
            enableControls={false}
            cameraPosition={[0, 0, 4.0]}
            fov={55}
            heroAreaMode={true}
            isHovered={isHovering}
          />
        </div>

        {/* Explore Button - Centered in logo (mobile & desktop) */}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <button
            onClick={handleExploreClick}
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
            onTouchStart={() => setIsHovering(true)}
            onTouchEnd={() => setIsHovering(false)}
            className="px-10 md:px-12 py-3.5 md:py-4 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full text-white font-semibold text-base md:text-lg hover:bg-white/20 hover:border-white/30 transition-all duration-300 hover:scale-105 active:scale-95 shadow-lg"
          >
            Explore
          </button>
        </div>
      </section>
    </div>
  );
};

export default Home;
